export default function Container({ children }) {
  return (
    <div style={{ width: "fit-content", margin: "0 auto" }}>{children}</div>
  );
}
